const highlights = [
  { icon: 'ri-test-tube-line', text: 'Green Hydrogen' },
  { icon: 'ri-leaf-line', text: 'Green Ammonia' },
  { icon: 'ri-truck-line', text: 'H2 Transport' },
  { icon: 'ri-ship-2-line', text: 'Export Projects' },
];

export default function HydrogenCTA() {
  return (
    <section className="relative overflow-hidden py-20 md:py-28">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Aerial%20panorama%20of%20large%20green%20hydrogen%20production%20facility%20with%20electrolyser%20halls%20and%20storage%20tanks%20next%20to%20massive%20solar%20farm%20in%20outback%20Australia%2C%20golden%20hour%20light%2C%20epic%20scale%20industrial%20photography%2C%20clean%20energy%20future%2C%20cinematic%20drone%20shot&width=1800&height=700&seq=hydrogen-cta-au-2026&orientation=landscape"
          alt="Australia's green hydrogen future — large-scale production facility"
          className="w-full h-full object-cover object-center"
          loading="lazy"
        />
        {/* Strong left-to-right dark ramp */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/97 via-black/90 to-black/65" />
        {/* Top + bottom fade */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-black/50" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
        {/* Backdrop panel for guaranteed contrast */}
        <div
          className="max-w-2xl rounded-2xl"
          style={{
            background: 'linear-gradient(135deg, rgba(0,0,0,0.50) 0%, rgba(0,0,0,0.20) 100%)',
            backdropFilter: 'blur(4px)',
            WebkitBackdropFilter: 'blur(4px)',
            padding: '2rem',
          }}
        >
          <div style={{ textShadow: '0 2px 20px rgba(0,0,0,0.90), 0 1px 6px rgba(0,0,0,0.75)' }}>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/25 border border-accent-400/40 mb-6">
              <div className="w-2 h-2 rounded-full bg-accent-400 animate-pulse-soft" />
              <span className="text-xs font-semibold text-accent-200 tracking-wide uppercase whitespace-nowrap">Australia&rsquo;s Trusted Renewable Energy Marketplace</span>
            </div>

            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-extrabold text-white leading-tight mb-5">
              Be Part of Australia&rsquo;s<br />Hydrogen Future
            </h2>

            <p className="text-base md:text-lg text-white leading-relaxed mb-4">
              AK Energy is Australia&rsquo;s trusted renewable energy marketplace, connecting customers, businesses and renewable energy providers to accelerate the transition towards cleaner energy solutions.
            </p>

            <p className="text-sm text-white/75 leading-relaxed mb-8">
              Whether you&rsquo;re a project developer, industrial off-taker, landowner, investor, or business seeking certified green hydrogen supply — AK Energy connects you with the right partners to move your hydrogen ambitions forward.
            </p>

            <div className="flex flex-wrap gap-2 mb-9">
              {highlights.map((h) => (
                <span
                  key={h.text}
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/15 border border-white/20 text-xs font-semibold text-white whitespace-nowrap"
                >
                  <i className={`${h.icon} text-accent-400`}></i>
                  {h.text}
                </span>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-3 mb-8">
              <a
                href="/#contact"
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-8 py-4 text-sm font-semibold rounded-xl bg-primary-500 text-white hover:bg-primary-400 transition-all duration-200 cursor-pointer"
              >
                Find Hydrogen Energy Providers
                <i className="ri-arrow-right-line text-lg"></i>
              </a>
              <a
                href="/wind-energy-solutions"
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-8 py-4 text-sm font-semibold rounded-xl bg-white/15 border border-white/30 text-white hover:bg-white/25 transition-all duration-200 cursor-pointer"
              >
                <i className="ri-windy-line text-lg"></i>
                Explore Wind Energy
              </a>
            </div>

            <div className="flex flex-wrap gap-4 text-xs text-white/55">
              <a href="/solar-energy-australia" className="hover:text-white/85 underline underline-offset-2 transition-colors">
                Solar Energy Australia
              </a>
              <span>·</span>
              <a href="/wind-energy-solutions" className="hover:text-white/85 underline underline-offset-2 transition-colors">
                Wind Energy Solutions
              </a>
              <span>·</span>
              <a href="/blog" className="hover:text-white/85 underline underline-offset-2 transition-colors">
                Renewable Energy Blog
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}